class Select2fn {
    static formatSelection(state) {
        if (!state.id) {
            return state.text; // Jika tidak ada ID, hanya teks yang dikembalikan
        }

        const dataset = state.element.dataset;

        switch (true) {
            case !!dataset.sym:
                return document.createRange().createContextualFragment(
                    `<i class="sym sym-${dataset.sym}"></i> ${state.text}`
                );
            case !!dataset.img:
                return document.createRange().createContextualFragment(
                    `<img src="${dataset.img}"  alt="state ${state.text}"> ${state.text}`
                );
            case !!dataset.dot:
                const variant = dataset.dot;
                return document.createRange().createContextualFragment(
                    `<span class="dot dot-${variant}"></span> ${state.text}`
                );
            default:
                return state.text; // Jika tidak ada dataset yang cocok, kembalikan teks saja
        }
    }

    static formatResult(state) {
        if (!state.id) {
            return state.text; // Jika tidak ada ID, hanya teks yang dikembalikan
        }

        const dataset = state.element.dataset;

        switch (true) {
            case !!dataset.sym:
                return document.createRange().createContextualFragment(
                    `<i class="sym sym-${dataset.sym}"></i> ${state.text}`
                );
            case !!dataset.img:
                return document.createRange().createContextualFragment(
                    `<img src="${dataset.img}"  alt="state ${state.text}"> ${state.text}`
                );
            case !!dataset.desc:
                return document.createRange().createContextualFragment(
                    `${state.text} <br> <span class="description">${dataset.desc}</span>`
                );
            case !!dataset.dot:
                const variant = dataset.dot;
                return document.createRange().createContextualFragment(
                    `<span class="dot dot-${variant}"></span> ${state.text}`
                );
            default:
                return state.text; // Jika tidak ada dataset yang cocok, kembalikan teks saja
        }
    }
}


export default Select2fn;
